import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

/**
 * Fetch paginated user ratings (admin).
 * config.params supports: minRating, maxRating, page, limit, sort
 */
function useGetAdminRatings(data = {}) {
  const { enabled = false, config = {}, queryKey } = data;
  const { params = {} } = config;
  const { privateFetch } = useContext(FetchContext);

  const key = queryKey ?? ['admin-user-ratings', params];

  return useQuery(
    key,
    () => privateFetch.get('/v1/admin/podcast/user-ratings', { params }).then((r) => r.data),
    { enabled, keepPreviousData: true }
  );
}

export default useGetAdminRatings;
